import { type ValidatorFn } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { type IScheduleRange } from '@principle-theorem/principle-core/interfaces';
import { isTime24hrType, type Time24hrType } from '@principle-theorem/shared';

/**
 * Angular types `ValidatorFn` as `(control) => ValidationErrors | null`, where
 * `null` is the required "no errors" value — `undefined` does not compile. This
 * is why the codebase's prefer-undefined rule is suppressed here.
 */
function closeAfterOpenValidator(): ValidatorFn {
  return (control) => {
    const from: unknown = control.get('from')?.value;
    const to: unknown = control.get('to')?.value;
    // Time24hrType is zero-padded HH:mm, so it orders correctly as a string —
    // the same comparison isWithinTimeRange relies on.
    if (!isTime24hrType(from) || !isTime24hrType(to) || to > from) {
      // eslint-disable-next-line no-null/no-null
      return null;
    }
    return { closeBeforeOpen: true };
  };
}

export class PracticeOpeningHoursFormGroup extends TypedFormGroup<IScheduleRange> {
  constructor() {
    super(
      {
        from: new TypedFormControl<Time24hrType>().withGuard(isTime24hrType),
        to: new TypedFormControl<Time24hrType>().withGuard(isTime24hrType),
      },
      { validators: closeAfterOpenValidator() }
    );
  }
}
